import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MessageBannerModule } from '../../notes/message-banner/message-banner.module';
import { PreloaderModule } from '../../notes/preloader/preloader.module';
import { CustomIframeComponent } from './custom-iframe.component';

@NgModule({
  declarations: [CustomIframeComponent],
  imports: [MessageBannerModule, CommonModule, RouterModule, PreloaderModule],
  exports: [CustomIframeComponent],
})
export class CustomIframeModule {}
